import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import { initSentry } from './lib/sentry.js';
import './index.css';

initSentry();

const BYPASS = import.meta.env.VITE_BYPASS_AUTH === 'true';
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const PRIMARY_DOMAIN = import.meta.env.VITE_CLERK_PRIMARY_DOMAIN; // e.g. "hub.sitruna.com"
const SIGN_IN_URL = import.meta.env.VITE_CLERK_SIGN_IN_URL; // e.g. "https://accounts.sitruna.com/sign-in"

if (!BYPASS && !PUBLISHABLE_KEY) {
  console.warn(
    'VITE_CLERK_PUBLISHABLE_KEY is not set. Copy apps/web/.env.example to .env and fill it in.'
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));

if (BYPASS) {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  );
} else {
  const host = typeof window !== 'undefined' ? window.location.host : '';
  const isSatellite =
    !!PRIMARY_DOMAIN && host && host !== PRIMARY_DOMAIN && !host.startsWith('localhost');

  const clerkProps = {
    publishableKey: PUBLISHABLE_KEY || 'pk_test_placeholder',
    ...(isSatellite && {
      isSatellite: true,
      domain: host,
      ...(SIGN_IN_URL && { signInUrl: SIGN_IN_URL }),
    }),
  };

  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <ClerkProvider {...clerkProps}>
          <App />
        </ClerkProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
}
